// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "summary-694ki";
var _3 = "passengers-2uLo5";
export { _1 as "__esModule", _2 as "summary", _3 as "passengers" }
export default { "__esModule": _1, "summary": _2, "passengers": _3 }
